import { createSlice } from '@reduxjs/toolkit';

import { getMultiUser, getProviderId, getUserType } from './constants';

const initialState = {
  providerId: getProviderId(),
  userType: getUserType(),
  isMultiUser: getMultiUser(),
};

export const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setProviderID: (state, action) => {
      state.providerId = action.payload;
    },
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setMultiUser: (state, action) => {
      state.isMultiUser = action.payload;
    },
  },
});

export const { actions } = auth;

export default auth.reducer;
